export default "__VITE_ASSET__52ed79fb__"